export const BIG_CALENDAR_VIEW = Object.freeze({
  month: 'month',
  workWeek: 'work_week',
  day: 'day',
})
